import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.ROUTES}`;

async function calculateRoute(payload) {
  const url = `${basePath}/route`;
  try {
    let response = await api.post(url, payload);
    let treated = errorHandling.handleResponse(response, "routingService.calculateRoute");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.calculateRoute");
    return null;
  }
}

async function fetchVehicleTypes() {
  const url = `${basePath}/vehicle-types`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchVehicleTypes");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchVehicleTypes");
    return null;
  }
}


async function fetchAllRoutes() {
  const url = `${basePath}`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchAllRoutes");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchAllRoutes");
    return null;
  }
}

// GET /api/v3/vehicles/routes/{routeId}
// Busca uma rota específica por ID
async function fetchRouteById(routeId) {
  const url = `${basePath}/${routeId}`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchRouteById");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchRouteById");
    return null;
  }
}


async function createRoute(payload) {
  const url = `${basePath}`;
  try {
    let response = await api.post(url, payload);
    let treated = errorHandling.handleResponse(response, "routingService.createRoute");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.createRoute");
    return null;
  }
}

export const routingService = {
  calculateRoute,
  fetchVehicleTypes,
  fetchAllRoutes,
  fetchRouteById,
  createRoute,
};
